<template>
  <YdDialog
    :title="title"
    :visible.sync="showVisible"
    append-to-body
    @close="closeEdit"
    width="60%"
    @open="openEdit"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      style="margin-left: 30px; margin-right: 10px"
      size="mini"
      label-position="left"
      label-width="100px"
    >
      <div class="title-box">基本信息</div>
      <el-form-item label="活动名称" prop="name">
        <el-input
          type="text"
          placeholder="不超过10个字"
          v-model="form.name"
          maxlength="10"
          show-word-limit
          style="width: 300px"
        />
      </el-form-item>
      <el-form-item label="隶属公司" prop="merchantId">
        <YdMerchantSelector
          v-model="form.merchantId"
          styles="width: 300px"
          placeholder="请选择隶属公司"
        />
      </el-form-item>
      <el-form-item label="活动时间" required>
        <el-date-picker
          v-model="form.startTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="开始日期"
          :picker-options="pickerOptionStart()"
          style="width: 200px"
        />
        <span> - </span>
        <el-date-picker
          v-model="form.endTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="结束日期"
          :picker-options="pickerOptionEnd()"
          style="width: 200px"
        />
      </el-form-item>

      <div style="display: flex; justify-content: space-between; align-items: center">
        <div class="title-box">活动奖励</div>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAddCoupon"
          size="mini"
          >添加优惠券/礼包</el-button
        >
      </div>
      <div style="padding-top: 10px; margin-bottom: 15px">
        <el-table :data="couponItem" border size="mini" max-height="280px">
          <el-table-column label="序号" type="index" width="50" align="center" />
          <el-table-column label="优惠券名称" align="center" prop="name" />
          <el-table-column label="所属礼包" align="center" prop="giftName" />
          <el-table-column label="金额/个" align="center" prop="discountsMoney" width="80" />
          <el-table-column label="剩余数量" align="center" prop="surplusNum" width="100" />
          <el-table-column label="每次领取数量" align="center" prop="num">
            <template slot-scope="scope">
              <avue-input-number v-model="scope.row.num" min-rows="0" style="width: 8vw" />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="deletes(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-form-item label="生成兑换码" prop="redemptionCodeNum">
        <el-input type="number" v-model="form.redemptionCodeNum" style="width: 150px" />份
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEdit">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>
    <select-coupon ref="selectCoupon" v-if="selectVisible" @getCouponItem="getCouponItem" />
  </YdDialog>
</template>

<script>
  import { getToken } from '@/util/auth'
  import SelectCoupon from '../../components/sendcoupon/select-coupon'
  import dayjs from 'dayjs'
  import { isEmpty } from 'lodash-es'

  export default {
    components: {
      SelectCoupon
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      formData: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        showVisible: false,
        selectVisible: false,
        headers: {
          Authorization: 'Bearer ' + getToken()
        },
        rules: {
          name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
          merchantId: [{ required: true, message: '请选择隶属公司', trigger: 'change' }],
          redemptionCodeNum: [{ required: true, message: '请输入生成兑换码', trigger: 'change' }]
        },
        form: {
          name: '',
          merchantId: '',
          startTime: '',
          endTime: '',
          couponRelationVos: [],
          redemptionCodeNum: 1
        },
        uploadDisabled: false,
        couponItem: [],
        isEdit: false,
        isAddPersonTime: false,
        title: '新增活动'
      }
    },
    mounted() {
      this.showVisible = this.visible
      if (!isEmpty(this.formData)) {
        this.title = '编辑'
        this.isEdit = true
        this.uploadDisabled = true
        this.form = {
          ...this.formData
        }

        this.$set(this.form, 'redemptionCodeNum', this.form.activityRedemption.totalCount)

        if (!isEmpty(this.formData.couponInfoList)) {
          this.formData.couponInfoList.forEach((item) => {
            item.name = item.couponName
          })
          this.couponItem = this.formData.couponInfoList
        }
      }
    },
    methods: {
      pickerOptionStart() {
        const s = dayjs().second()
        const m = dayjs().minute()
        const h = dayjs().hour()
        return {
          // 日期限制
          disabledDate: (time) => {
            return Date.now() - 3600 * 1000 * 24 > time.getTime()
          },
          // 时间限制
          selectableRange: h + ':' + m + ':' + s + '- 23:59:59'
        }
      },
      pickerOptionEnd() {
        if (!this.form.startTime) {
          return
        }
        const s = dayjs(this.form.startTime).second()
        const m = dayjs(this.form.startTime).minute()
        const h = dayjs(this.form.startTime).hour()
        return {
          // 日期限制
          disabledDate: (time) => {
            return time.getTime() < new Date(this.form.startTime).getTime() - 86400000
          },
          // 时间限制
          selectableRange: h + ':' + m + ':' + s + '- 23:59:59'
        }
      },
      handleAddCoupon() {
        this.selectVisible = true
        this.$nextTick(() => {
          this.$refs.selectCoupon.init()
        })
      },

      save() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (!this.form.startTime || !this.form.endTime) {
              this.$message.info('请先选择活动时间！')
              return
            }
            this.form.couponRelationVos = this.couponItem.map((item) => {
              return {
                couponId: item.id || item.couponId,
                type: item.type,
                num: item.num
              }
            })
            if (this.isEdit) {
              delete this.form.personTime
            }
            this.$emit('saveEdit', this.form)
          }
        })
      },
      closeEdit() {
        this.uploadDisabled = false
        this.form = {
          name: '',
          merchantId: '',
          startTime: '',
          endTime: '',
          couponRelationVos: []
        }
        this.showVisible = false
        this.isEdit = false
        this.isAddPersonTime = false
        this.couponItem = []
        this.$emit('closeEdit')
      },

      deletes(index) {
        this.couponItem.splice(index, 1)
      },
      getCouponItem(couponItem) {
        this.couponItem.push(...couponItem)
        this.couponItem = this.couponItem.filter((item, index, self) => {
          return self.findIndex((el) => el.id === item.id) === index
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .tipsBox {
    display: inline-block;
    font-size: 13px;
    color: #9f9f9f;
    margin-left: 10px;
  }

  .disabled ::v-deep .el-upload--picture-card {
    display: none;
  }

  .disabled ::v-deep .el-upload__tip {
    margin-top: -10px;
  }
</style>
